import {
  ChecklistSectionModel,
  InspectionTemplateModel,
} from 'shared/domain/template/inspectionTemplateModel';
import { UserEntity } from 'shared/domain/user/types/entity';
import { InspectionTemplateEntity, ChecklistSectionEntity } from './entity';
import { entityToModelBase } from 'shared/domain/toBaseModel';

function sectionEntityToModel(
  section: ChecklistSectionEntity,
  users: UserEntity[]
): ChecklistSectionModel {
  const sectionBase = entityToModelBase({ entity: section, users });
  return {
    ...sectionBase,
    title: section.title,
    description: section.description,
    order: section.order,
    documents: section.documents,
    items: section.items,
    parentSectionId: section.parentSectionId,
  };
}

export function inspectionTemplateEntityToModel(
  entity: InspectionTemplateEntity,
  users: UserEntity[]
): InspectionTemplateModel {
  const modelBase = entityToModelBase({ entity, users });
  const {
    checklist,
    generalNorm,
    generalNormConfig,
    process,
    status,
    summary,
    sections,
  } = entity;
  return {
    ...modelBase,
    checklist,
    sections: (sections || []).map((section) =>
      sectionEntityToModel(section, users)
    ),
    generalNorm,
    generalNormConfig,
    process,
    status,
    summary,
  };
}
